import {
  IItemParamOrderSimulate,
  IMeasureUnit
} from '../../../../../store/ducks/order-simulate-checkout-mvp/types';
import { formatNumberWithLocale } from '../../../../../utils/formatNumbers';

export const formatTotalWeight = (items: IItemParamOrderSimulate[]) => {
  const totalWeight = getCalculateTotalWeight(items);
  return Number(totalWeight.quantityInT) < 1
    ? `${formatNumberWithLocale({
        value: totalWeight.quantityInKg,
        min: 1
      })} Kg`
    : `${formatNumberWithLocale({ value: totalWeight.quantityInT, min: 1 })} t`;
};

export const getCalculateTotalWeight = (items: IItemParamOrderSimulate[]) => {
  let quantityInT = 0;
  let quantityInKg = 0;

  items.forEach((item) => {
    const valueInKg = convertToKg(
      Number(item.quantity),
      item.measureUnits,
      item.unityMeasure
    );
    quantityInKg += valueInKg;
    const valueInTon = convertKgToTon(valueInKg);
    quantityInT += valueInTon;
  });

  return {
    quantityInKg,
    quantityInT
  };
};

/**
 *
 * @param itemQuantity selected quantity of item
 * @param measureUnits available measurement units
 * @param unityMeasure item's selected unit of measure
 * @returns value converted to unit of measurement KG
 */
export const convertToKg = (
  itemQuantity: number,
  measureUnits: IMeasureUnit[],
  unityMeasure: string
): number => {
  const measureUnit = measureUnits.find(
    (mu) => mu.measure.toLowerCase() === unityMeasure.toLowerCase()
  );

  const minQuantity = parseFloat(measureUnit?.minimumQuantity ?? '0');
  const multiple = parseFloat(measureUnit?.multiple ?? '0');
  const convMeasureKg = parseFloat(
    measureUnit?.convMeasureKg.replace(/\./g, '').replace(',', '.') ?? '0'
  );

  let valueInKg = itemQuantity * convMeasureKg;

  // Se a quantidade for menor que a quantidade mínima, ajuste para o múltiplo
  if (valueInKg < minQuantity) {
    valueInKg = Math.ceil(valueInKg / multiple) * multiple;
  }

  return valueInKg;
};

export const convertKgToTon = (valueInKg: number) => {
  return valueInKg / 1000;
};
